// xt 2025-01-25: This filename should be TopNav or otherwise should match class. sloppy original code.
//                Top nav bar for all pages. Incidents and Reports show for all users.
//                Responder tab shown if user has "is_admin" in auth0.app_metadata,
//                should change to "respondertab" flag, as is_admin shows all agencies.
//                Added Map Tab, visible to all users.
// xt 20250614: Replaced react-bootstrap with Bootstrap 5.3.3, matches Navbar.css styles.
// xt 20250614: Added isActive to fix persistent active state, enhanced Responders debug.
// xt 20250614: Refined Incidents isActive to exclude other routes, class component - Grok/xAI
// xt 20250704: comopletely refactor as functional comp an use auth0 correctly w/ chat
// xt 20260809: add stats tab

import React, { Component, useEffect, useState } from 'react';
//import { connect } from 'react-redux';
import { NavLink, Link, useNavigate } from 'react-router-dom'; // these are used to load or redirect to other pages
import { useSelector, useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { invalidateAgency } from '../../actions/agencyStubs';
// import PropTypes from 'prop-types';
// import AuthService from '../../utils/AuthService';
import Logo from '../../assets/images/BSGWhiteLOGO.png';
import './Navbar.css';

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { logout } = useAuth0();


  // const profileFromRedux = useSelector((state) => state.profile || {}); // no .details
  // const [profile, setProfile] = useState(profileFromRedux);

  // useEffect(() => { // useEffect ensues that localstorage allback is used only once, and only if Redux is empty
  //   if (!profileFromRedux?.email) {
  //     try {
  //       const stored = JSON.parse(localStorage.getItem('profile'));
  //       if (stored?.email) {
  //         setProfile(stored);
  //       }
  //     } catch (e) {
  //       console.warn('Navbar - could not parse localStorage profile', e);
  //     }
  //   } else {
  //     setProfile(profileFromRedux);
  //   }
  // }, [profileFromRedux]);

  const cachedProfile = localStorage.getItem('profile');
  console.log('navbar like 47 this is cachedProfile from ls ', cachedProfile)
  const profile = useSelector((state) => state.profile || {});

  if (
    !profile || !profile.user_metadata) {
    // Profile not ready, don't render yet
    return null; // Or <Spinner /> or blank until profile is fully ready
  }

  console.log('in Navbar, line 32 this is profile, ', profile);

  const agency = useSelector((state) => state.agency || {});
  const agencyPermissions = profile.app_metadata?.agency_permissions || [];


  // Define visibility booleans for each tab, default false if not set
  const tabAccess = profile.app_metadata?.tab_access || {};
  const showIncidentsTab = tabAccess.incidents === true;
  const showRespondersTab = tabAccess.responders === true;
  const showMapTab = tabAccess.map === true;
  const showReportsTab = tabAccess.reports === true;
  const showConfigTab = tabAccess.config === true; // 1/12/26 add config tab
  const showStatsTab = tabAccess.stats === true;

  // we may get rid of this logic and just rely on tab access in user account
  const hasResponderPermission = () => {
    const agencyId = agency.agencyId;
    const permission = agencyPermissions.find((perm) => perm.id === '*' || perm.id === agencyId);
    return (
      permission?.read_responder_locations ||
      permission?.departments?.some((dept) => dept.read_responder_locations)
    );
  };

  const showResponderTab = () => {
    const isAdmin = profile.app_metadata?.is_admin;
    return isAdmin && hasResponderPermission();
  };
  // this is end of old logic


  const handleLogout = () => {
    // Dispatch Redux resets
    dispatch({ type: 'RESET_PROFILE' });
    dispatch({ type: 'INVALIDATE_AGENCY' });

    // Clean up localStorage
    localStorage.removeItem('selected_agency');
    localStorage.removeItem('profile');

    // Remove Auth0 SDK keys
    const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID; // or import from config/env
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(`@@auth0spajs@@::${auth0ClientId}`)) {
        localStorage.removeItem(key);
      }
    }

    // Finally, log out from Auth0 and redirect
    logout({
      logoutParams: {
        returnTo: `${window.location.origin}/login`,
      },
    });

  };

  //console.log('navbar 57. ready to render navbar')

  return (
    <nav id="top-nav" className="navbar navbar-expand-lg navbar-dark">
      <div className="container-fluid">
        <div className="navbar-header">
          <img className="logo" src={Logo} alt="Brass Star Group" height="40" />
        </div>
        <ul className="navbar-nav me-auto">
          <li className="nav-item">
            <NavLink
              to="/dashboard"
              end
              className={({ isActive }) =>
                isActive || window.location.pathname === '/' ? 'nav-link active' : 'nav-link'
              }
            >
              Incidents
            </NavLink>
          </li>
          {showResponderTab() && (
            <li className="nav-item">
              <NavLink
                to="/responders"
                end
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                Responders
              </NavLink>
            </li>
          )}
          <li className="nav-item">
            <NavLink
              to="/maptabview"
              end
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Map
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/reports"
              end
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Reports
            </NavLink>
          </li>
          {showConfigTab && (
            <li className="nav-item">
              <NavLink
                to="/config"
                end
                className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
              >
                Config
              </NavLink>
            </li>
          )}
          {showStatsTab && (
            <li className="nav-item">
              <NavLink
                to="/stats"
                end
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Stats
              </NavLink>
            </li>
          )}
        </ul>

        {(profile?.user_metadata?.name || profile?.name) && (
          <ul className="navbar-nav">
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="profileDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  className="profile-picture"
                  src={profile.picture}
                  alt="Profile"
                  style={{ width: '30px', height: '30px', borderRadius: '50%' }}
                />
                <span className="ms-2">
                  {profile.user_metadata?.name || profile.name}
                </span>
              </a>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
                <li>
                  <button className="dropdown-item logout-button" onClick={handleLogout}>
                    Logout
                  </button>
                </li>
              </ul>
            </li>
            <li className="nav-item d-flex align-items-center">
              <button className="nav-link logout-link btn btn-link align-items-center" onClick={handleLogout}>
                Logout
              </button>
            </li>
            <li className="nav-item">
              <i className="material-icons help-icon">help</i>
            </li>
          </ul>
        )}
      </div>
    </nav>
  );
};

export default Navbar;